import styled from 'styled-components';

interface SurveyInputHeaderProps {
  inputTitle: string;
  canDuplicate?: boolean;
  isRequired?: boolean;
  isOptional?: boolean;
}

export const SurveyInputHeader = ({
  inputTitle,
  canDuplicate = false,
  isRequired = false,
  isOptional = false,
}: SurveyInputHeaderProps) => {
  return (
    <FormHeaderContainer>
      <FormTitle>{inputTitle}</FormTitle>
      {canDuplicate && (
        <GreenChip>
          <GreenChipText>{'중복 선택 가능'}</GreenChipText>
        </GreenChip>
      )}

      {!canDuplicate && isRequired && (
        <RedChip>
          <RedChipText>{'필수'}</RedChipText>
        </RedChip>
      )}

      {!canDuplicate && isOptional && (
        <GreyChip>
          <GreyChipText>{'선택'}</GreyChipText>
        </GreyChip>
      )}
    </FormHeaderContainer>
  );
};

const FormHeaderContainer = styled.div`
  width: 100%;
  min-height: 22px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FormTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

const Chip = styled.div`
  height: 22px;

  display: flex;
  align-items: center;

  padding: 6px 8px;
  gap: 2px;

  border-radius: var(--radius-small, 4px);
`;

const GreenChip = styled(Chip)`
  background: var(--Light-Scheme-Color-secondary-green, #d6f4e5);
`;

const GreyChip = styled(Chip)`
  background: var(--Light-Scheme-Color-secondary-green, #f2f2f7);
`;

const RedChip = styled(Chip)`
  background: var(--Light-Scheme-Color-secondary-green, #ffdbe0);
`;

const ChipText = styled.span`
  text-align: center;

  /* System/Small/s-medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 10.2px */
`;

const GreenChipText = styled(ChipText)`
  color: var(--Light-Scheme-Color-primary-green, #34c77e);
`;

const GreyChipText = styled(ChipText)`
  color: var(--Light-Scheme-Color-primary-green, #505363);
`;

const RedChipText = styled(ChipText)`
  color: var(--Light-Scheme-Color-primary-green, #ff3049);
`;
